export const TEMPLATES_HREF = '/advisor/dashboard/templates';
export const TEMPLATE_NEW_HREF = '/advisor/dashboard/templates/new';

export function templateEditHref(id: string): string {
  return `${TEMPLATE_NEW_HREF}?id=${id}`;
}
